module.exports = __webpack_public_path__ + "img/female8.1c4266dd.jpeg";